export const siteInfo = {
  name: '98堂',
  fullName: '98堂 入口',
  tagline: '官方直达通道，安全快速登录',
  description: '98堂 入口是您访问98堂平台的官方直达渠道，提供最新可用地址、安全登录指引及快速入口导航。无论何时何地，通过98堂 入口即可稳定访问，享受流畅体验。收藏本页，永不迷路。',
  url: 'https://98tang.com',
  logo: '98堂',
  foundingYear: '2018',
  email: 'contact@98tang.com',
  phone: '400-888-9898',
  address: '北京市朝阳区建国路98号',
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '使用指南', href: '/category/guide' },
  { label: '常见问题', href: '/category/faq' },
  { label: '安全公告', href: '/category/security' },
  { label: '关于我们', href: '/about' },
];

export const latestAddresses = [
  { id: 1, url: 'https://www.98tang.com', label: '主入口地址', status: 'available', speed: '极快', region: '全球' },
  { id: 2, url: 'https://98tang.net', label: '备用入口一', status: 'available', speed: '快速', region: '亚洲' },
  { id: 3, url: 'https://98tang.org', label: '备用入口二', status: 'available', speed: '快速', region: '欧美' },
  { id: 4, url: 'https://98tang.cc', label: '镜像入口', status: 'available', speed: '稳定', region: '全球' },
];

export const loginSteps = [
  { step: 1, title: '访问官方入口', description: '通过本页提供的官方地址访问98堂平台，确保使用最新可用链接，避免钓鱼网站风险。', icon: 'ri-link' },
  { step: 2, title: '注册或登录账号', description: '新用户点击注册按钮创建账号，老用户直接输入用户名和密码进行登录。建议使用强密码保障账户安全。', icon: 'ri-user-add-line' },
  { step: 3, title: '完成安全验证', description: '根据提示完成滑块验证或短信验证码验证，确保账户操作安全可靠，防止恶意登录。', icon: 'ri-shield-check-line' },
  { step: 4, title: '开启畅快体验', description: '登录成功后即可畅享98堂全部功能与服务，建议开启二次验证提升账户安全等级。', icon: 'ri-rocket-line' },
];

export const features = [
  { title: '稳定访问', description: '多线路智能调度，确保99.9%的访问成功率，无论何时何地都能稳定连接。', icon: 'ri-router-line' },
  { title: '安全加密', description: '全站HTTPS加密传输，保护用户隐私数据不被窃取，提供银行级安全防护。', icon: 'ri-lock-line' },
  { title: '极速响应', description: '全球CDN加速节点覆盖，页面加载速度极快，提供流畅无缝的浏览体验。', icon: 'ri-flashlight-line' },
  { title: '实时更新', description: '地址信息实时同步更新，确保您始终通过最新有效的入口访问平台。', icon: 'ri-refresh-line' },
  { title: '多端兼容', description: '完美适配PC、平板、手机等各类设备，随时随地便捷访问。', icon: 'ri-device-line' },
  { title: '专业支持', description: '7x24小时客服在线，遇到任何访问问题均可获得及时专业的技术支持。', icon: 'ri-customer-service-2-line' },
];

export const faqItems = [
  { question: '98堂入口地址无法访问怎么办？', answer: '首先请确认您使用的是本页提供的最新官方地址。如仍无法访问，可尝试切换备用入口，或清除浏览器缓存后重试。若问题持续，建议检查本地网络设置或联系在线客服获取帮助。' },
  { question: '如何判断是否访问的是官方正版入口？', answer: '请认准本页列出的官方域名地址。官方入口具备HTTPS安全证书，页面底部有完整的联系方式和备案信息。切勿通过搜索引擎广告或不明链接进入，以免误入仿冒网站。' },
  { question: '忘记账号密码如何找回？', answer: '在登录页面点击"忘记密码"，按提示输入注册时使用的手机号或邮箱，系统将发送验证码。验证通过后即可重设密码。若注册信息已变更，请联系客服人工处理。' },
  { question: '98堂支持哪些设备和浏览器？', answer: '98堂支持Windows、Mac、iOS、Android等主流操作系统，兼容Chrome、Safari、Edge、Firefox等现代浏览器。建议保持浏览器为最新版本以获得最佳体验。' },
  { question: '账户安全问题如何保障？', answer: '98堂采用多重安全防护机制，包括SSL加密传输、登录异常监测、操作行为分析等。建议用户开启手机验证或二次验证，定期修改密码，不在公共设备上保存登录状态。' },
  { question: '收藏本页有什么好处？', answer: '收藏本页后，您可以随时通过书签快速找到最新官方入口，无需担心地址变更或遗忘。本页将始终保持更新，是您访问98堂最可靠的导航站点。' },
];

export const stats = [
  { value: '500万+', label: '累计服务用户' },
  { value: '99.9%', label: '访问可用率' },
  { value: '7x24', label: '全天候技术支持' },
  { value: '10年+', label: '稳定运营时长' },
];